import { cn } from '@heroui/react';
import { MdOutlineHighlightOff } from 'react-icons/md';

interface ClearButtonProps {
  isVisible?: boolean;
  onClear: () => void;
  hasCounter?: boolean;
}

export const ClearButton = ({ isVisible, onClear, hasCounter }: ClearButtonProps) => {
  if (!isVisible) {
    return null;
  }

  return (
    <button
      onClick={onClear}
      className={cn(
        'absolute right-2 p-1 rounded-full hover:bg-default-200 transition-colors cursor-pointer text-base-30 hover:text-base-10 z-10 -translate-y-1/2',
        hasCounter ? 'top-[calc(50%-8px)]' : 'top-1/2',
      )}
      type="button"
    >
      <MdOutlineHighlightOff className="size-4" />
    </button>
  );
};
